import React from "react";
import PropTypes from "prop-types";

const ContactInfo = ({ data }) => {
    return (
        <div className={data.classOption}>
            <h4 className="title">{data.title}</h4>
            <a className="address-link" href={data.href}>
                <p dangerouslySetInnerHTML={{ __html: data.info }}></p>
            </a>
        </div>
    );
};

ContactInfo.propTypes = {
    data: PropTypes.object,
};

export default ContactInfo;
